import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Divider } from "@mui/material";
import { FC } from "react";

interface WasPriceConfirmationDialogProps {
  open: boolean;
  loading: boolean;
  perks: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const WasPriceConfirmationDialog: FC<WasPriceConfirmationDialogProps> = ({
  open,
  loading,
  perks,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>
            Values will be loaded directly into the pricing database and appear on the website and the was price
            overrides are <b>{perks ? "for perks" : "public"}.</b>
          </p>
          <p>I have verified the values are correct.</p>
          <Divider flexItem />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No, go back
        </Button>
        <LoadingButton
          loading={loading}
          onClick={() => {
            onConfirm();
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
